export class PartnerOnboarding {
    Id: number | null;
    PartnerOnboardingGuid: string;
    PartnerId: number;
    NotificationEmailAddress: string;
    Status: PartnerOnboardingStatus;
    Data: PartnerOnboardingData;

    constructor(source?: Partial<PartnerOnboarding>) {
      if (source) {
          Object.assign(this, source);
      }
    }
}

export class PartnerOnboardingData {
  Input: PartnerOnboardingInput;
  Output: PartnerOnboardingOutput;
}

export class PartnerOnboardingInput {
  DefaultContactTypes: PartnerContactType[];
  IdentificationTypes: IdentificationType[];
  DocumentTypesIn: DocumentTypeInput[];
  DocumentTypesOut: DocumentTypeInput[];
  SupportedTransports: Transport[];
}

export class PartnerOnboardingOutput {
  Name: PartnerName;
  Contact: PartnerContact;
  Identifications: Identification[];
  DocumentTypesIn: DocumentTypeOutput[];
  DocumentTypesOut: DocumentTypeOutput[];
  Note: string;

  constructor(source?: Partial<PartnerOnboardingOutput>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class PartnerName {
  Name: string;
  Status: PartnerOnboardingItemStatus;
  ConversationId: string;

  constructor(source?: Partial<PartnerName>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class PartnerContact {
  Name: PartnerContactName;
  Email: PartnerContactEmail;
  PhoneNumber: PartnerPhoneNumber;
  Types: PartnerContactType[];

  constructor(source?: Partial<PartnerContact>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class PartnerContactType {
  Id: number | null;
  Name: string;

  constructor(source?: Partial<PartnerContactType>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class PartnerContactName {
  ContactName: string;
  Status: PartnerOnboardingItemStatus;
  ConversationId: string;

  constructor(source?: Partial<PartnerContactName>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class PartnerContactEmail {
  ContactEmail: string;
  Status: PartnerOnboardingItemStatus;
  ConversationId: string;

  constructor(source?: Partial<PartnerContactEmail>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class PartnerPhoneNumber {
  PhoneNumber: string;
  Status: PartnerOnboardingItemStatus;
  ConversationId: string;

  constructor(source?: Partial<PartnerPhoneNumber>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class Identification {
  IdentificationType: IdentificationType;
  Value: string;
  Status: PartnerOnboardingItemStatus;
  ConversationId: string;

  constructor(source?: Partial<Identification>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class IdentificationType {
  Id: number | null;
  Name: string;

  constructor(source?: Partial<IdentificationType>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class DocumentTypeInput {
  Id: number | null;
  Name: string;
  DisplayName: string;
  Formats: Format[];
}

export class DocumentTypeOutput {
  Id: number | null;
  Name: string;
  Format: Format;
  Transport: Transport;
  Status: PartnerOnboardingItemStatus;
  ConversationId: string;

  constructor(source?: Partial<DocumentTypeOutput>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class Format {
  Id: number | null;
  Name: string;

  constructor(source?: Partial<Format>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class PartnerOnboardingItemStatus {
    Status: ItemStatus;
    CreatedEntities: CreatedEntity[];

    constructor(source?: Partial<PartnerOnboardingItemStatus>) {
      if (source) {
          Object.assign(this, source);
      }
    }
}

export class PartnerConversation {
  Id: string;
  Comments: PartnerOnboardingComment[];
  CustomerLastRead: Date | null;
  PartnerLastRead: Date | null;

  constructor(source?: Partial<PartnerConversation>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class FormPartnerConversation extends PartnerConversation {
    AreaId: string;
    constructor(conversation: PartnerConversation, areaId: string | null) {
        super(conversation);
        this.AreaId = areaId;
    }
}

export class PartnerOnboardingComment {
  FromCustomer: boolean;
  IsAction: boolean;
  Message: string;
  Timestamp: Date;

  constructor(source?: Partial<PartnerOnboardingComment>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class NewCommentEvent {
  ConversationId: string;
  Comment: PartnerOnboardingComment;

  constructor(source?: Partial<NewCommentEvent>) {
      if (source) {
          Object.assign(this, source);
      }
  }
}

export class ToggleConversationEvent {
  ConversationId: string;
  AreaId: string | null;

  constructor(source?: Partial<ToggleConversationEvent>) {
      if (source) {
          Object.assign(this, source);
      }
  }
}

export class CreatedEntity {
  Id: number;
  Name: string;

  constructor(source?: Partial<CreatedEntity>) {
    if (source) {
        Object.assign(this, source);
    }
  }
}

export class Transport
{
  Type: TransportType;
  TransportFields: TransportField[];
  CredentialsStatus: CredentialsStatus;

  constructor(source?: Partial<Transport>) {
    if (source) {
        Object.assign(this, source);
    }
  }

  hasPartnerFilledTransportFields(documentDirection: DocumentDirection): boolean {
    if (!this.TransportFields) {
      return false;
    }
    return this.TransportFields.some(field => field.FilledBy === TransportFieldOwner.Partner && (field.DocumentDirection === documentDirection || field.DocumentDirection === DocumentDirection.Both));
  }

  hasCustomerFilledTransportFields(documentDirection: DocumentDirection): boolean {
    if (!this.TransportFields) {
      return false;
    }
    return this.TransportFields.some(field => field.FilledBy === TransportFieldOwner.Customer && (field.DocumentDirection === documentDirection || field.DocumentDirection === DocumentDirection.Both));
  }
}

export class TransportField
{
  Name: string;
  Value: string;
  Configuration: string;
  Presentation: string;
  Description: string;
  Type: TransportFieldType;
  FilledBy: TransportFieldOwner;
  DocumentDirection: DocumentDirection;
  ConversationId: string;
}

export class As2Details {
  As2Url: string;
  As2Partners: As2Partner[];
  SupportedSigningAlgorithms: string[];
  As2HttpHandlers: As2HttpHandler[];
}

export class As2Partner {
  Id: number;
  Name: string;
  As2Ids: string[];
  PublicCertificate: As2Certificate;
}

export class As2HttpHandler {
  Name: string;
  As2Url: string;
  PublicCertificate: As2Certificate;
}

export class As2Certificate {
  Name: string;
  SerialNumber: string;
  Data: string;
}

export enum PartnerOnboardingStatus {
  Unknown = 'Unknown',
  InProgress = 'InProgress',
  PartnerDone = 'PartnerDone',
  Done = 'Done'
}

export enum ItemStatus {
  Open = 'Open',
  AwaitingAcceptance = 'AwaitingAcceptance',
  Accepted = 'Accepted'
}

export enum TransportType {
  Unknown = 'Unknown',
  SFTPCustomerEndpoint = 'SFTPCustomerEndpoint',
  SFTPPartnerEndpoint = 'SFTPPartnerEndpoint',
  FTPCustomerEndpoint = 'FTPCustomerEndpoint',
  FTPPartnerEndpoint = 'FTPPartnerEndpoint',
  IntegratedFTP = 'IntegratedFTP',
  IntegratedSFTP = 'IntegratedSFTP',
  AS2 = 'AS2'
}

export enum TransportFieldType {
  Unknown = 'Unknown',
  String = 'String',
  File = 'File',
  Dropdown = 'Dropdown',
  Password = 'Password',
  Credentials = 'Credentials'
}

export enum TransportFieldOwner {
  Partner = 'Partner',
  Customer = 'Customer'
}

export enum DocumentDirection {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  Both = 'Both'
}

export enum CredentialsStatus {
  Unknown = 'Unknown',
  NotProvided = 'NotProvided',
  Requested = 'Requested',
  Provided = 'Provided'
}
